<template>
    <div class="filling">
        <div v-if="istop" class="banner1"><img src="../assets/images/banner.png"></div>
        <div class="line"></div>
        <div class="contFill">
            <el-tabs :tab-position="tabPosition" @tab-click="change">
                <el-tab-pane v-for="(item,index) in filling[index]" :key="index" :label="item.name">
                    <tabright :col_ids='item.str' :sub='item.sub'></tabright>
                </el-tab-pane>            
            </el-tabs>
        </div>
    </div>
</template>

<script>
import tabright from '../../src/components/TabRight'
export default {
data() {
    return {
        tabPosition: 'left',
        istop:1,
        filling:[
            [
                {
                    name:"畲乡头条",
                    str:[195],
                    sub:[
                    ]
                },
                {
                    name:"习语讲堂",
                    str:[46,72,71],
                    sub:[
                        {
                            name:"习近平文汇",
                            str:[46],
                        },
                        {
                            name:"平语近人",
                            str:[72],
                        },
                        {
                            name:"重要讲话",
                            str:[71],
                        }                        
                    ]
                },
                {
                    name:"印象畲乡",
                    str:[196],
                },
                {
                    name:"畲视频",
                    str:[197],
                },   
                {
                    name:"政策规划",
                    str:[198],
                },
                {
                    name:"铁军赶考",
                    str:[199],
                },
                {
                    name:"点赞畲乡",
                    str:[200],
                },
                {
                    name:"红色畲乡",
                    str:[201],
                },                                          
            ],
            [
                {
                    name:"工作动态",
                    str:[192]
                },
                {
                    name:"视频展播",
                    str:[193]
                },
                {
                    name:"文化活动",
                    str:[194]
                },                                             
            ],
            [
                {
                    name:"科技科普",
                    str:[161,162,166,165,87,88,89,75,76,77,78,79,80,81],
                    sub:[
                        {
                            name:"科普实践基地",
                            str:[161],
                        },
                        {
                            name:"科普中国",
                            str:[162],
                        },
                        {
                            name:"青少年科技竞赛",
                            str:[166],
                        },
                        {
                            name:"有声科普",
                            str:[165],
                        },
                        {
                            name:"农技110",
                            str:[87],
                        },
                        {
                            name:"农科百事通",
                            str:[88],
                        },
                        {
                            name:"农广院讲座",
                            str:[89],
                        },
                        {
                            name:"科学防疫",
                            str:[75],
                        },
                        {
                            name:"养生保健",
                            str:[76],
                        },
                        {
                            name:"疾病防治",
                            str:[77],
                        },
                        {
                            name:"健康心理",
                            str:[78],
                        },
                        {
                            name:"营养膳食",
                            str:[79],
                        },
                        {
                            name:"急救复苏",
                            str:[80],
                        },
                        {
                            name:"紧急避险",
                            str:[81],
                        },
                        {
                            name:"丽水科协",
                            str:"http://lskp.lishui.gov.cn/",
                        }                   
                    ]
                },
                {
                    name:"全民健身",
                    str:[92,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,97,98,99,100,101,102,103,104,105,106,107,108,109,110,112,90],
                    sub:[
                        {
                            name:"小苹果大讲堂",
                            str:[92],
                        },
                        {
                            name:"专家问诊",
                            str:[113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135],
                        },
                        {
                            name:"养生健体",
                            str:[97,98,99,100,101,102,103],
                        },
                        {
                            name:"老年大学",
                            str:[104,105,106,107,108,109],
                        },
                        {
                            name:"舞动神州",
                            str:[110,112],
                        },
                        {
                            name:"肿瘤百科",
                            str:[90],
                        },  
                    ]                  
                },
                {
                    name:"老有所乐",
                    str:[104,105,106,107,108,109],
                    sub:[
                        {
                            name:"戏舞",
                            str:[104],
                        },
                        {
                            name:"书法",
                            str:[105],
                        },
                        {
                            name:"乐器",
                            str:[106],
                        },
                        {
                            name:"科学",
                            str:[107],
                        },
                        {
                            name:"绘画",
                            str:[108],
                        },
                        {
                            name:"摄影",
                            str:[109],
                        },                                               
                    ]
                },   
                {
                    name:"爱心帮扶",
                    str:[66]
                }                                       
            ],  
            [
                {
                    name:"德润畲乡",
                    str:[209]
                },
                {
                    name:"文明实践进行时",
                    str:[208]
                }, 
                {
                    name:"文明好习惯",
                    str:[211]
                },
                {
                    name:"乡风文明",
                    str:[214]
                },
                {
                    name:"先锋模范",
                    str:[215]
                },
                {
                    name:"清廉文化",
                    str:[216]
                },
                {
                    name:"文明创建",
                    str:[210]
                },                                    
            ],           
        ]
            
    };
},
methods: {
    change:function(tab,event){
        // console.log(tab)
        if(tab.label == "礼堂家"){
            window.open("http://www.zjwhlt.cn/");  
        }else if(tab.label == "书香丽水"){
            window.open("http://sxlslib.chineseall.cn/home/index");  
        }
    }
},
computed: {
    index:function(){
        return this.$route.query.id
    }
},
mounted() {
    var istop = this.$route.query.isTop;
    if(istop == 0){
         console.log(istop)
         this.istop = 0
    }
},
components: {
    tabright
},
}
</script>
<style lang="less">
.filling{
    margin: 0 auto;
    .banner1{
        position: relative;
        width: 100%;
        img{
            width: 100%;
        }
    }
    .line{
        width: 100%;
        height: 8px;
        background-color: #f5f6f8;
        margin: 30px 0;
    }
    .contFill{
        width: 1200px;
        min-height: 600px;
        margin: 0 auto;
        padding-bottom: 80px;
        .is-active {
            color: #fff !important;
            background-image: linear-gradient(#fcb399, #f39389);
            border-bottom: 0 !important;
        }
        .el-tabs--left .el-tabs__nav-wrap.is-left::after, .el-tabs--left .el-tabs__nav-wrap.is-right::after, .el-tabs--right .el-tabs__nav-wrap.is-left::after, .el-tabs--right .el-tabs__nav-wrap.is-right::after{
            height: 0 !important;
        }
        .el-tabs__active-bar{
            display: none;
        }
        .el-tabs__item:hover{
            color: #4a4c60 !important;
        }
        .is-active:hover{
            color: #fff !important;
        }
        .el-tabs__item{
            width: 355px !important;
            height: 98px !important;
            line-height: 98px !important;
            font-size: 32px !important;
            text-align: left !important;
            border-bottom: 1px solid #666;
        }
    }
    
}

</style>